import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Card, Col, Descriptions, Row, Tag, Typography, message } from "antd";
import ListTable from "common/ListTable";
import { DIGITALIZATION_CHECKLIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";

export default function BuyerWiseChecklistView() {
  const [checklistData, setChecklistData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const getSupervisorChecklist = useCallback(async () => {
    setLoading(true);
    const query = `${DIGITALIZATION_CHECKLIST}/${id}`;
    const response = await getData(query);
    setLoading(false);
    if (response?.status === 200) {
      console.log("response?.data?.data", response?.data?.data);

      setChecklistData(response?.data?.data || {});
    } else {
      message.error("Something went wrong! Please try again.");
    }
  }, [id]);

  useEffect(() => {
    getSupervisorChecklist();
  }, [id, getSupervisorChecklist]);

  const columns = [
    {
      title: "Question",
      dataIndex: ["question", "name"],
      key: "question",
    },
    {
      title: "Answer",
      dataIndex: "answer",
      key: "answer",
      render:(row) => row === "yes" ?  <Tag color="green">Yes</Tag> :  <Tag color="volcano">No</Tag>
    },
    {
      title: "Reason",
      dataIndex: "manual_reason",
      key: "reason",
    },
  ];

  return (
    <Row gutter={4}>
      <Col span={24}>
        <Card
          title={<Typography.Title level={4}>Checklist Info</Typography.Title>}
          bordered
          style={{
            margin: "10px 20px",
            padding: "10px",
          }}
        >
          <Descriptions column={4}>
            <Descriptions.Item label="Buyer">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.buyer?.name}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Style">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.style?.style_no}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Name">
              <Typography.Text level={2} strong>
                {checklistData?.user?.name}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.user?.phone}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.user?.email}
              </Typography.Text>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col span={24}>
        <Card
          title={<Typography.Title level={4}>Checklists</Typography.Title>}
          bordered
          style={{
            margin: "10px 20px",
            padding: "10px",
          }}
        >
          <ListTable
            loading={loading}
            dataSource={checklistData?.question_answeres || []}
            columns={columns}
            emptyText="No records to show yet."
          />
        </Card>
      </Col>
    </Row>
  );
}
